import React from "react";

//CSS
import "./ActivityCard.css";

//Hooks and functions
import { useTranslation } from "react-i18next";

export default function ActivityCard({
  activity = {
    User: "Miki test",
    Action: "Create",
    ObjectType: "Item",
    DateTime: "28/04/20025 18:32",
    Detail: "Sraf fsad",
  },
  first = false,
  last = false,
}) {
  const { t } = useTranslation();

  let action;
  if (activity.Action === "Create") {
    action = "created";
  } else if (activity.Action === "Edit") {
    action = "edited";
  } else if (activity.Action === "Delete") {
    action = "deleted";
  } else if (activity.Action === "Remove") {
    action = "removed";
  } else {
    action = " ";
  }
  action = t(action);
  return (
    <div className="activity-card">
      <div
        className={
          "line-decoration " + (first ? "first" : "") + (last ? "last" : "")
        }
      ></div>
      <div className="activity-card-details">
        <span className="activity-card-text">
          {t("User") + " "}{" "}
          <span className="highlighted">{activity.Username}</span>
          {" " + action + " " + t(activity.ObjectType)}{" "}
          <span className="highlighted">{activity.Detail}</span>
          {". " + t("Date and time") + ": "}
          <span className="highlighted">{activity.DateTime}</span>
        </span>
      </div>
    </div>
  );
}
